"use strict";

function closestMultipleOf50(numArray) {
  // Calculate the remainder

  let num = Math.max(...numArray)
  let remainder = num % 50;
  return num + (50 - remainder);

}

var KTChartsWidget40 = (function () {
  var initChart = function (chartSelector) {
    var elementList = document.querySelectorAll(chartSelector);

    if (!elementList) {
      return;
    }

    elementList.forEach((element, index) => {
      var height = parseInt(KTUtil.css(element, "height"));

      var leftCol = yillikKarsilastirmaArray[index]["series"][0];
      var rightCol = yillikKarsilastirmaArray[index]["series"][1];
      var difference = rightCol["data"].map(
        (item, index) => Math.round((item / leftCol["data"][index]) * 100)
      );



      var maxVal = Math.round(Math.max(...difference.concat(leftCol["data"].concat(rightCol["data"]))) * 1.25);

      var options = {
        series: [
          {
            name: "2023",
            type: "column",
            data: leftCol["data"],
          },
          {
            name: "2024",
            type: "column",
            data: rightCol["data"],
          },
          {
            name: "Oran",
            type: "line",
            data: difference,
          },
        ],
        chart: {
          height: height || 300,
          type: "line",
          stacked: false,
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [1, 1, 4],
        },
        title: {
          show: false,
          enabled: false,
          text: undefined,
          align: "left",
          offsetX: 110,
        },
        xaxis: {
          categories: [
            "Oca",
            "Şub",
            "Mar",
            "Nis",
            "May",
            "Haz",
            "Tem",
            "Ağu",
            "Eyl",
            "Eki",
            "Kas",
            "Ara",
          ],
        },
        yaxis: [
          // 2023 Sütun konfigürasyon
          {
            enabled: true,
            show: true,
            min: 0,
            max: maxVal,
            axisTicks: {
              show: false,
            },
            axisBorder: {
              show: true,
              color: leftCol["color"],
            },
            labels: {
              style: {
                colors: leftCol["color"],
              },
            },
            title: {
              text: undefined,
              style: {
                color: leftCol["color"],
              },
            },
            tooltip: {
              enabled: false,
            },
          },

          // 2024 sütun konfigürasyon
          {
            seriesName: "2024",
            opposite: true,
            show: false,
            min: 0,
            max: maxVal,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: rightCol["color"],
            },
            labels: {
              style: {
                colors: rightCol["color"],
              },
            },
            title: {
              text: undefined,
              style: {
                color: rightCol["color"],
              },
            },
          },

          // Oran konfigürasyon
          {
            min: 0,
            max: closestMultipleOf50(difference),
            seriesName: "Oran",
            opposite: true,
            show: true,
            tickAmount: 5,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: "#3F4254",
            },
            labels: {
              style: {
                colors: "#3F4254",
              },
            },
            title: {
              text: undefined,
              style: {
                color: "#3F4254",
              },
            },
          },
        ],
        tooltip: {
          fixed: {
            enabled: false,
            show: false,
            position: "topLeft", // topRight, topLeft, bottomRight, bottomLeft
            offsetY: 30,
            offsetX: 60,
          },
        },
        legend: {
          show: true,
          horizontalAlign: "center",
        },
        colors: [leftCol["color"], rightCol["color"], "#3F4254"]
      };

      var chart = new ApexCharts(element, options);
      chart.render();
    });
  };

  // Public methods
  return {
    init: function () {
      initChart(".compare_widget_selector");
    },
  };
})();

// Webpack support
if (typeof module !== "undefined") {
  module.exports = KTChartsWidget40;
}

// On document ready
KTUtil.onDOMContentLoaded(function () {
  KTChartsWidget40.init();
});
